import React, { useEffect, useMemo, useState } from 'react'

import {
  Box,
  CheckboxGroup,
  Checkbox,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  Input,
  Divider,
  Text,
  MenuOptionGroup,
  MenuItemOption,
  MenuDivider,
  MenuGroup,
  Select,
} from '@chakra-ui/react'
import { RxCross1 } from 'react-icons/rx'

const TextFilter = ({ value, setValue, direction = 'column' }) => {
  const [filterType, setFilterType] = useState('contain')
  const [filterText, setFilterText] = useState('')

  useEffect(() => {
    if (!value || typeof value !== 'string') {
      setFilterType('contain')
      setFilterText('')
      return
    }

    const match = value.match(/^type__([a-zA-Z0-9]+)--(.+)$/)

    if (!match) {
      return
    }

    setFilterType(match[1])
    setFilterText(match[2])
  }, [value])

  //Translated

  const handleFilterTypeChange = (e) => {
    const newFilterType = e.target.value
    setFilterType(newFilterType)

    if (filterText === '' || newFilterType === '') {
      return
    }
    setValue(`type__${newFilterType}--${filterText}`)
  }

  const handleFilterTextChange = (e) => {
    const newFilterText = e.target.value
    setFilterText(newFilterText)
  }

  const handleOnBlur = () => {
    if (filterText === '' || filterType === '') {
      setValue('')
      return
    }

    setValue(`type__${filterType}--${filterText}`)
  }

  return (
    <Flex direction={direction} gap="2" w="100%">
      <Select onChange={handleFilterTypeChange} placeholder="Select" value={filterType} maxW="200px">
        <option value="contain">Contain</option>
        <option value="notContain">Not Contain</option>
        <option value="equal">Equals</option>
        <option value="notEqual">Does not equals</option>
        <option value="beginWith">Begin With</option>
        <option value="endWith">End With</option>
      </Select>

      <Input
        type="text"
        placeholder="Filter by"
        onChange={handleFilterTextChange}
        onBlur={handleOnBlur}
        value={filterText}
        disabled={!filterType}
      />
    </Flex>
  )
}

export default TextFilter
